import * as Section from "./section";
import * as Code from "./code";
import * as Paragraph from "./paragraph";
import * as BlogPost from "./blog-post";
import * as BlogList from "./blog-list";
import * as BlogPostCollection from "./blog-post-collection";

// Order matters and mirrors `types` in ../fields.js — see the note there.
export const schema = [
  ...Section.schema,
  ...Code.schema,
  ...Paragraph.schema,
  ...BlogPost.schema,
  ...BlogList.schema,
  ...BlogPostCollection.schema,
];
